module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppAddBookingButton', {
    scopedSlots: _vm._u([{
      key: "CaseAndAmount",
      fn: function(props) {
        return [_c('v-flex', {
          attrs: {
            "xs12": "",
            "align-center": "",
            "justify-space-between": ""
          }
        }, [_c('v-select', {
          attrs: {
            "items": props.casesList,
            "label": "Select case"
          },
          model: {
            value: (props.selectedCase.id),
            callback: function($$v) {
              _vm.$set(props.selectedCase, "id", $$v)
            },
            expression: "props.selectedCase.id"
          }
        })], 1)]
      }
    }, {
      key: "ItemsSelection",
      fn: function(props) {
        return [_c('v-flex', {
          attrs: {
            "md12": ""
          }
        }, [_c('v-select', {
          attrs: {
            "items": props.servicesList,
            "label": "Select whom to book"
          },
          scopedSlots: _vm._u([{
            key: "item",
            fn: function(props) {
              return [_vm._v("\n              " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n            ")]
            }
          }, {
            key: "selection",
            fn: function(props) {
              return [_vm._v("\n              " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n            ")]
            }
          }], null, true),
          model: {
            value: (props.selectedService.id),
            callback: function($$v) {
              _vm.$set(props.selectedService, "id", $$v)
            },
            expression: "props.selectedService.id"
          }
        })], 1)]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78bb8268","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/AddBookingButton.vue
// module id = 1009
// module chunks = 1